var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.96967 9.03033C1.67678 8.73744 1.67678 8.26256 1.96967 7.96967L5.96967 3.96967C6.26256 3.67678 6.73744 3.67678 7.03033 3.96967C7.32322 4.26256 7.32322 4.73744 7.03033 5.03033L4.31066 7.75L13.5 7.75C13.9142 7.75 14.25 8.08579 14.25 8.5C14.25 8.91421 13.9142 9.25 13.5 9.25H4.31066L7.03033 11.9697C7.32322 12.2626 7.32322 12.7374 7.03033 13.0303C6.73744 13.3232 6.26256 13.3232 5.96967 13.0303L1.96967 9.03033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft16);
export default __webpack_public_path__ + "static/media/arrowLeft-16.ac8ab4e2.svg";
export { ForwardRef as ReactComponent };